module.exports = __webpack_public_path__ + "json/market13-0.json?f1068760eba323fb57b553a80eaf6d4e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market13-0.json
// module id = 1256
// module chunks = 3